export const userTypes = [
  { label: "Appraiser", value: "LR" },
  { label: "Reviewer", value: "FR" },
];

export const planPeriods = ["2025-26", "2024-25", "2023-24", "2022-23"];
